import type { DashboardSchedule } from "../../services/schedules.service";
import { Card, CardContent } from "@/components/ui/card";

type SummaryMetric = {
  label: string;
  value: number;
};

function SummaryCard({ label, value }: SummaryMetric) {
  return (
    <Card className="rounded-lg py-4">
      <CardContent className="px-4">
        <p className="text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground">
          {label}
        </p>
        <p className="mt-2 text-2xl font-semibold">{value}</p>
      </CardContent>
    </Card>
  );
}

export function ScheduleSummaryCards({
  busyCount,
  schedules,
}: {
  busyCount: number;
  schedules: DashboardSchedule[];
}) {
  const metrics: SummaryMetric[] = [
    { label: "Total", value: schedules.length },
    {
      label: "Enabled",
      value: schedules.filter((schedule) => schedule.enabled).length,
    },
    { label: "Running", value: busyCount },
  ];

  return (
    <div className="grid gap-3 md:grid-cols-3">
      {metrics.map((metric) => (
        <SummaryCard key={metric.label} {...metric} />
      ))}
    </div>
  );
}
